export const formTemplates = [
  {
    title: '单列表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t1.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json1.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '多列表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t2.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json2.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '分组表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t3.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json3.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '标签页表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t4.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json4.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '主从表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t5.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json5.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '响应式表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t6.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json6.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '问卷调查表',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t7.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json7.txt',
    description: '表单模板详细说明...'
  },

  {
    title: '固定表格表单',
    imgUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/t8.png',
    jsonUrl: 'https://ks3-cn-beijing.ksyuncs.com/vform-static/form-samples/json8.txt',
    description: '表单模板详细说明...'
  },

]

export function clearFormTemplates() {
  formTemplates.splice(0, formTemplates.length)
}

export function addFormTemplate(newFormTemplate) {
  formTemplates.push(newFormTemplate)
}

export function getAllFormTemplates() {
  return formTemplates
}



// WEBPACK FOOTER //
// ./src/components/form-designer/widget-panel/templatesConfig.js